import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import RequestAccess from "../../../components/requestAccess/RequestAccess";
import Utils from "../../../utils/Utils";
import Loader from "../../../components/Loader";
import WebUtils from "../../../utils/WebUtils";
import { getModuleAccessInfoApi } from "../../../api/candidate";
import { ROLES } from "../../../constants/UserRoles";
import CVMain from "../../../components/b2bCandidate/cvOptimizer/optimizeResume/CVMain";
import { Segmented } from "antd";
import AllResumesMain from "../../../components/b2bCandidate/cvOptimizer/AllResumesMain";

function EditResume() {
  const userDetail = Utils.getUserDetail();

  const [loading, setLoading] = useState(false);
  const [moduleInfo, setModuleInfo] = useState();

  const getModuleInfo = async () => {
    const url = `${getModuleAccessInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setModuleInfo(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getModuleInfo();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="hirePlusPlusPageContent">
        <Sidebar
          collapseSidbar="left"
          activePage="cv-optimizer"
          userRole={
            userDetail?.userRole === "JOBDRONA_CANDIDATE"
              ? "candidate"
              : ROLES.b2b_candidate
          }
        />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="cv-optimizer"
            userRole={
              userDetail?.userRole === "JOBDRONA_CANDIDATE"
                ? "candidate"
                : ROLES.b2b_candidate
            }
            newTitle="Edit Resume"
            noNavigate={false}
          />
          <div className="px-5">
            <CVMain setLoading={setLoading} />
          </div>
          {/* {moduleInfo?.hasMockTestAccess && <div></div>}
          {moduleInfo?.hasMockTestAccess === false && (
            <RequestAccess moduleName="CV_OPTIMIZER" />
          )} */}
          {/* <RequestAccess moduleName="CV_OPTIMIZER" /> */}
        </div>
      </div>
    </>
  );
}

export default EditResume;
